import ApplePreviewBaseController from "./apple_preview_base_controller"
import {
  extractMappedValue,
  fieldDisplayLabel,
  fieldsGroupedByPlatformSlot
} from "../field_mapping_preview_support"
import { buildApplePreviewState } from "./preview_state_builder"

function buildAppleMappingPayload(c) {
  return buildApplePreviewState({
    name: c.nameValue,
    show_name_on_apple_card: c.showNameOnAppleCardValue,
    background_colour: c.backgroundColourValue || "#ffffff",
    foreground_colour: c.foregroundColourValue || "#000000",
    label_colour: c.labelColourValue || "#000000",
    ios_logo: c.iosLogoValue || "",
    ios_strip: c.iosStripValue || "",
  })
}

export default class AppleCardPreviewMappingController extends ApplePreviewBaseController {
  static values = {
    name: String,
    backgroundColour: String,
    foregroundColour: String,
    labelColour: String,
    showNameOnAppleCard: Boolean,
    iosLogo: String,
    iosStrip: String,
  }

  connect() {
    this.applyApplePreview(this.mappingPayload())
    this.applyPlacement({}, {})
  }

  disconnect() {
    this.releaseObjectUrls()
  }

  applyPlacement(fields, sample) {
    const byPos = fieldsGroupedByPlatformSlot(fields, "apple")
    this.setStripName(byPos.HeaderTop, sample)
    this.setAppleQrSlot(byPos.code)
    this.setHeaderRight(byPos.HeaderRight, sample)
    this.setFieldOne(byPos.Row1Left, sample)
    this.setFieldTwo(byPos.Row1Mid, sample)
    this.setFieldThree(byPos.Row1Right, sample)
  }

  setStripName(entry, sample) {
    if (!this.hasAppleMemberNameTarget) return
    if (!entry) {
      this.appleMemberNameTarget.textContent = ""
      return
    }
    this.appleMemberNameTarget.textContent = extractMappedValue(sample, entry.def) || ""
  }

  setAppleQrSlot(entry) {
    if (this.hasAppleQrTarget) this.appleQrTarget.classList.toggle("d-none", !entry)
  }

  setHeaderRight(entry, sample) {
    if (this.hasAppleHeaderRightTarget) {
      this.appleHeaderRightTarget.classList.toggle("d-none", !entry)
    }
    this.setPair(
      this.hasAppleHeaderRightLabelTarget ? this.appleHeaderRightLabelTarget : null,
      this.hasAppleHeaderRightValueTarget ? this.appleHeaderRightValueTarget : null,
      entry,
      sample
    )
  }

  setFieldOne(entry, sample) {
    this.setPair(
      this.hasAppleField1LabelTarget ? this.appleField1LabelTarget : null,
      this.hasAppleField1ValueTarget ? this.appleField1ValueTarget : null,
      entry,
      sample
    )
  }

  setFieldTwo(entry, sample) {
    this.setPair(
      this.hasAppleField2LabelTarget ? this.appleField2LabelTarget : null,
      this.hasAppleField2ValueTarget ? this.appleField2ValueTarget : null,
      entry,
      sample
    )
  }

  setFieldThree(entry, sample) {
    this.setPair(
      this.hasAppleField3LabelTarget ? this.appleField3LabelTarget : null,
      this.hasAppleField3ValueTarget ? this.appleField3ValueTarget : null,
      entry,
      sample
    )
  }

  setPair(labelEl, valueEl, entry, sample) {
    if (!labelEl && !valueEl) return
    if (!entry) return this.fillPair(labelEl, valueEl, "", "")
    const lbl = fieldDisplayLabel(entry.key, entry.def)
    const val = extractMappedValue(sample, entry.def) || ""
    this.fillPair(labelEl, valueEl, lbl, val)
  }

  fillPair(labelEl, valueEl, lbl, val) {
    if (labelEl) labelEl.textContent = lbl
    if (valueEl) valueEl.textContent = val
  }

  mappingPayload() {
    return buildAppleMappingPayload(this)
  }
}
